import {Component, OnDestroy, ViewEncapsulation} from '@angular/core';

@Component({
    selector     : 'fade-in-animation',
    templateUrl  : './fade-in-animation.component.html',
    styleUrls    : ['./fade-in-animation.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FadeInAnimationComponent implements OnDestroy {

    /**
     * Constructor
     */
    constructor(
    ) {
    }

    ngOnDestroy(): void {
    }
}
